import { useQuery } from '@apollo/client';
import { QueryItemsResponse } from 'common/models/graphql';
import { IchiJson } from 'common/models/ichiJson';
import { Treasury } from 'common/models/treasury';
import { REFRESH_INTERVALS } from 'constants/constants';
import { graphql, useStaticQuery } from 'gatsby';
import { listTreasuriesOnChainQuery } from 'graphql/queries/listTreasuries.query';
import React, { FC } from 'react';
import TreasuryTable from '../common/components/TreasuryTable/TreasuryTable';
import useSelectedChain from 'hooks/useSelectedChain';
import { RouteComponentProps } from '@reach/router';

type Props = {
  version?: number;
};

const TreasuryTableContainer: FC<Props & RouteComponentProps> = (props) => {
  const { chainId } = useSelectedChain();

  const { data } = useQuery<QueryItemsResponse<Treasury>>(
    listTreasuriesOnChainQuery(chainId),
    {
      fetchPolicy: 'cache-and-network',
      pollInterval: REFRESH_INTERVALS['listTreasuries'],
    }
  );

  const StaticData: IchiJson = useStaticQuery(graphql`
    query {
      ichiJson {
        TREASURY_TABLE {
          headers {
            name
            helpText
          }
        }
      }
    }
  `);

  let treasuries: Treasury[] = data?.listTreasuries?.items || [];
  if (props.version != null) {
    treasuries = treasuries.filter(
      (item) => item.oneTokenVersion === props.version
    );
  }
  const table = StaticData.ichiJson.TREASURY_TABLE;
  return (
    <div className="table-wrapper">
      <TreasuryTable table={table} treasuries={treasuries} />
    </div>
  );
};

export default TreasuryTableContainer;
